var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#d3d3d3;stroke-miterlimit:10;stroke-width:10px;}.cls-2{fill:#d3d3d3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Humlog_Icons_4 Feb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250,
    cy: 250,
    r: 240
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.7,110a96.26,96.26,0,0,0-71.2,161.08l-7.35,7.35a17.69,17.69,0,0,0-21.33,2.79l-78.65,78.66a17.64,17.64,0,1,0,25,24.95l78.66-78.65a17.69,17.69,0,0,0,2.79-21.33l7.35-7.35A96.28,96.28,0,1,0,293.7,110ZM212.36,299.76,133.7,378.42a8.57,8.57,0,0,1-12.12-12.13l78.66-78.65a8.57,8.57,0,0,1,12.12,12.12Zm81.34-6.23a87.23,87.23,0,1,1,87.23-87.23,87.33,87.33,0,0,1-87.23,87.23Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.14,201.77H298.23V153.86a4.54,4.54,0,0,0-9.07,0v47.91h-47.9a4.54,4.54,0,1,0,0,9.07h47.9v47.9a4.54,4.54,0,0,0,9.07,0v-47.9h47.91a4.54,4.54,0,0,0,0-9.07Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.d3f6135ae7bada43354a763583cc3f53.svg";
export { ForwardRef as ReactComponent };